export const user_position_lang={
    TH:{
      header_map:"ข้อมูลแผนที่",
      header_table:"ข้อมูลตำแหน่งของพนักงาน",
      search:"ค้นหา",
      user_id: "รหัสพนักงาน",
      user_name: "ชื่อพนักงาน",
      phoneno: "เบอร์โทรศัพท์",
      status: "สถานะ",
      lastlogin:"เข้าสู่ระบบครั้งล่าสุด"
    },
    EN:{
      header_map:"Map",
      header_table:"User information",
      search:"Search",
      user_id: "Employee code	",
      user_name: "Employee Name",
      phoneno: "Phone No",
      status: "Status",
      lastlogin:"Lastlogin"

    }
  }
  